// Module
var code = `<div class="notificationsPanelSideBar" on-mousedown="@this.onMouseDown(event)">
    {{#if .showCategoryToolbar}}
        <div class="notificationsPanelSideBar-container-header {{.headerBodyRightOpened}}">
            <div class="categories-item-container">
                {{#each categories: i}}
                    {{#if categories[i].visible}}
                        <div class="categories-item {{i == selectedCategory ? 'selected' : ''}} {{categories[i].isAllCategory ? 'AllCategory' : ''}}"
                             on-click="['categoryClick',i]">
                             <div class="line" style="{{!categories[i].isAllCategory ? 'background-color: ' + categories[i].colorHEXstr + ';' : ''}}"></div>
                             <div class="text">
                                {{categories[i].name + (unreadByCategory[i] ? (' (' + unreadByCategory[i] + ')') : '') }}
                            </div>
                        </div>
                    {{/if}}
                {{/each}}
            </div>
        </div>
    {{/if}}

    <div class="notificationsPanelSideBar-container-body" {{#if !.allMessages}}style="display: none;" {{/if}}>
        <div class="notificationsPanelSideBar-container-body-left">
            <div class="cards-item-container">
                {{#each cards: i}}
                    <notificationsItemSideBar notification="{{cards[i]}}" on-onCardClick="onCardClick" />
                {{/each}}
            </div>
        </div>

        {{#if .selectedCard}}
            <div class="notificationsPanelSideBar-container-body-right">
                <div class="title">{{selectedCard.Title}}</div>

                <div class="content_container">
                    <div class="right-content">
                        <div class="content-text bm-content-text-{{selectedCard.DisplayMethod}}">
                            <iframe srcdoc="{{selectedCard.Text}}" class="right-iframe"></iframe>
                        </div>
                    </div>

                    <div class="right-custom-buttons">
                        {{#each selectedCard.CustomButtons: i}} <!-- BM's Custom Buttons -->
                            <terceraButton name="{{'customButton'+i}}"
                                           width="{{customButtonWidth}}"
                                           text="{{selectedCard.CustomButtons[i].Title}}"
                                           tooltip="{{selectedCard.CustomButtons[i].Tooltip}}"
                                           terceraButtonStyle="js-button-gray25"
                                           on-btnClick="['onCustomButton' + i + 'Click']" />
                        {{/each}}
                    </div>
                </div>
            </div>
        {{/if}}
    </div>

    {{#if !.allMessages}}
        {{>noData}}
    {{/if}}

</div>`;
// Exports
export default code;